import { mapActions, mapGetters } from "vuex";
export default {
    props: ["list", "isMobile"],
    data() {
        return {}
    },
    methods: {
        ...mapActions([
            'toggleMobileMenu'
        ]),
    },
    computed: {
        showLogOut() {
            return this.isMobile && this.isLoggedIn
        },
        ...mapGetters([
            'isAdmin',
            'getMenuStatus',
            'ticketMessagesExists',
            'isLoggedIn'
        ])
    },

}